import React, { Component } from 'react';
import { firebaseDb } from 'src/firebase';


import { Conversation, Select, Question, Option } from 'react-conversation-form/dist/';


class ConvoBot extends Component {
  constructor() {
    super();
    
    this.state = {
      displayChat:true
    };
    this.onSubmit=this.onSubmit.bind(this)
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
  }
  
  componentDidMount() {
    window.scrollTo(0, 0)
  }


  onSubmit(e){
    e.formGoogleSheetName = "Colivingly"
    e.sheetName = "makers"
    this.setState({
      displayChat:false
    })
   //email to spreadsheet
   var googlescript ='https://script.google.com/macros/s/AKfycbxkOCYFV-_vmw_9IsTxM44aW1IOupGDBxcWvmaGA67FIDQael1w/exec'
   const proxyurl = "https://req.prototypr.io/";

   fetch(proxyurl+googlescript, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(e)
  })
   console.log(e)
  }

  render () {
    if(this.state.displayChat==true){

    return(
      <div style={{position:'relative'}}>
        <Conversation
              onSubmit={(e) => { this.onSubmit(e)}}
              style={{zIndex:'1'}}
              chatOptions={{
                  thankTheUser: ['identifier'],
                  introText: 'Hello, welcome to Colivingly!\n👋 I am Huggy, the Coliving Koala.&&I have some questions for you! Answers will be used to match you with people looking for living situations in a similar location and timeframe 🏡.',
                  submitText: 'Thanks for giving us your feedback!'
              }}
          >

          <Select id="letsgo" question="Ready to start?">
              <Option value="y">👍 Yeah, let's go!</Option>
          </Select>
          <Question id="name" question="Great, first though what's your name?">
          </Question>
          <Select id="worksituation" question="Great! Now let's get started with some work-related questions.&&What's your current employment situation?">
              <Option value="selfemployed">Self Employed/Freelancing</Option>
              <Option value="employed">I'm employed full time</Option>
              <Option value="founder">Company (co)founder</Option>
          </Select>
          <Select id="currently" question="Do you currently work remotely?">
              <Option value="yes">Yes, 100% remote</Option>
              <Option value="some">Yes, part of the time.</Option>
              <Option value="no">No</Option>
          </Select>
          
          <Select id="dates" question="When are you looking to move?">
              <Option value="asap">ASAP</Option>          
              <Option value="soon">Within the next 2 months</Option>
              <Option value="6mo">Within the next 6 months</Option>
              <Option value="12mo">Next year</Option>
          </Select>
          <Question id="where" showUserThinking={true} question="✈️ Where are you open to moving? List any regions or countries you like!">
          </Question>
          <Select id="budget" question="💰 What's your monthly budget for accomodation?">
              <Option value="low">0-€600</Option>          
              <Option value="medium">0-€1200</Option>
              <Option value="medhigh">€1200-€2000</Option>
              <Option value="high">€2000+</Option>
          </Select>
          
          <Question id="project" >
              {'Great! Now to find out you\'re working on 😍.&&Please list your project(s) or outline any ideas you have in the pipeline.'}
          </Question>
          <Question id="social" >
              {'Do you use 🐦 Twitter or 📷Instagram?&&Please paste links to any social media profiles you\'re comfortable sharing.&&These will increase the speed of verification and get you on Coiving List.'}
          </Question>
          <Question id="website" >
              {'Thanks!&&Do you have a personal website? Please paste that too if you do!'}
          </Question>
          <Select id="feedbackType" question="Okay, last question.&&Cats or dogs?">
              <Option value="issue">😸 Cats</Option>
              <Option value="typo">🐶 Dogs</Option>
          </Select>
      </Conversation>
    </div>
    );
  }

    else if(this.state.displayChat==false){
      return(
        <div>
          <div className="padding-m " style={{textAlign:'center'}}>

              <img width="300" style={{ borderRadius:'10px', maxWidth:'100%',margin:'0 auto'}} src="/images/1f428.png"/>
              <h2 style={{color:'#666'}}>Thank you! I have recorded your submission.<br/>We will let you know when you have access to the list.</h2>

          </div>
        </div>
      )
    }
    else {
      return(
        <div>
        Bleep bloop
        </div>
      
      )
    }

  }
}

export default ConvoBot;



// WEBPACK FOOTER //
// ./src/views/components/convo-bot/convo-bot.js